var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"questionnaire"},[(_setup.questionnaireUrl)?_c('iframe',{staticClass:"questionnaire-frame",attrs:{"src":_setup.questionnaireUrl,"frameborder":"0"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }